
import { FamilyDetail } from '../family-details/family-detail.service';
//import { IMedicalFilePlace} from '../medicalfileplace/medicalfileplace.service';
import { IName } from '../../blocks/names/name.component';
import { IIdentity } from '../../blocks/identity_type/identity_type.component';
import { IAddress } from '../../hospitalSetup/address/address.component';
import { TherapeuticCards } from '../contracts/index';
import { EmrPatHistory } from '../../medical-recored/medical-recored.interfaces';


export interface PatientData {
    patient?: Patient;
    familyDetail?: FamilyDetail[];
    familyPatients?: Patient[];
    therapeuticCards: TherapeuticCards;
    docManagementData?: any;
    patients?: Patient[];
    emrPatHistory?: EmrPatHistory
}

export interface PatCancel {
    patCode: number;
    fullNameAr?: string;
    FullNameEn?: string;
    identityType?: number;
    identityValue?: number;
}

export interface Patient {
    code: number;
    motherPatCode?: number
    checkValidation?: number
    oldCode: string;
    customCode: string;
    regBirthDataSerial?: number
    // name area
    unKnownFlag?: number;
    age?: number
    dateHijri?: Date;
    fnameAr: string;
    fnameEn: string;
    patCode: number;
    snameAr: string;
    snameEn: string;
    tnameAr: string;
    tnameEn: string;
    lnameAr: string;
    lnameEn: string;
    fullnameAr?: string;
    fullnameEn?: string;
    oldCodeFullnameAr?: string;
    oldCodeFullnameEn?: string;
    gender?: number;
    religionId?: number;
    maritalStatus?: number;
    patientOccupation?: number;
    birthDate?: Date;
    birthPlace?: string;
    // address area
    nationalityId?: number;
    countryCode?: number;
    govCode?: number;
    cityCode?: number;
    villageCode?: number;
    fullAddressAr?: string;
    fullAddressEn?: string;
    identityType: any;
    identityValue?: string;
    bloodGroup?: number;
    rhValue?: number;
    contractId: any;
    contractNameAr?: string;
    contractNameEn?: string;
    parentId?: number;
    fatherName?: string;
    motherName?: string;
    mortalityDate?: Date;
    fileNo?: string;
    stopFlag?: number;
    vipFlag?: number;
    //change user data
    changeType?: number;
    mortaliyFlag?: number;
    mailAddress?: string;
    mobile?: number;
    countryKey?: number;
    familyMobile?: string;
    chronic?: number;
    chronicToolTip?: string;
    homePhone?: number;
    titleCode?: number;
    employeeId?: number;
    vipLevel?: number;
    nickName?: string;
    villageNameAr: string;
    villageNameEn: string;
    floorCode?: number

    cityNameAr: string;
    cityNameEn: string;

    countryNameAr: string;
    countryNameEn: string;

    govNameAr: string;
    govNameEn: string;

    nationalityNameEn: string;
    nationalityNameAr: string;

    genderNameAr: string;
    genderNameEn: string;

    religionNameAr: string;
    religionNameEn: string;

    parentEn: string;
    parentAr: string;

    titleNameEn: string;
    titleNameAr: string;

    identityEn: string;
    identityAr: string;

    employeeEn: string;
    employeeAr: string;

    bloodGroupAr: string;
    bloodGroupEn: string;

    maritalStatusEn: string;
    maritalStatusAr: string;

    relativeDegree?: number;
    familyCount?: number;

    contractsAr?: string;
    contractsEn?: string;
    drGeneralNotes?: string;
    // calculated
    ageAr?: string;
    ageEn?: string;
    // search parms
    fastSearchData: string;
    offset?: number;
    pageSize?: number;
    rowsCount?: number;
    bornWeight?: number;
    newBornPatCode?: number;
    statusType?: number;
    ngbFromDate?: Date;
    ngbToDate?: Date;
    base64?: string;
    docPath?: string;
    savePlaceType?: number;
    mergedFlag?: number;
    patientCode?: number;
    mergedByPatCode?: number;
    haveSpecialNeed?: number;
    specialNeedType?: number;
    specialNeedDesc?: string;
    cCCallBeneficiaryCode?: number;
    // user login for patient
    userName?: string;
    password?: string;
    confirmedUser?: number;
    securityQuestion?: string;
    answer?: string;

    docId?: number;
    branchId?: number;
    startDate?: any;
    comingFrom: number;
    activationCode?: string;
    activated?: boolean;
    registerStep?: number;
    MembershipCardNo?: string
    updateStatus: number;
    regIncubationPatMainDataSerial: number;
    newPatient?: number;
    lastPlacePatientNameAr?: string;
}

export interface PatientVM extends Patient {
    name: IName;
    therapeuticCards: TherapeuticCards;
    address: IAddress;
    identity: IIdentity;
    dateHijriNgb: any;
    birthDateNgb: any;
    chronic?: any;
    mortalityDateNgb: any;
    visitType: number;
    visitStatus: number;
    // visitsList?:string
    companyType: number;
    companyCode?: number;
    branchCompanyCode?: number;
    billNotExtracted: number;
    namingTranslationSettings: number;
    addressAr?: string;
    addressEn?: string;
    // providerUrl ?: string;
    MembershipCardNo?: string
    visitDays?: number;
    heelSampleFlag?: number;
    hepatitisEpidemicSampleFlag?: number;
    serviceId?: number;
    serviceStatus: number;
    payed: number;
    compFirstLevelCode?: number;
    compSecondLevelCode?: number;
}
export interface Reg_IncubationPatMainData extends Patient {
    serial: number;
    // customCode : number;
    titleCode: number;
    transDate: Date;
    fullKidNameAr?: string;
    fullKidNameEn?: string;
    fullPapaNameAr?: string;
    fullPapaNameEn?: string;
    fullMamaNameAr?: string;
    fullMamaNameEn?: string;
    motherAge: number;
    patientAge?: number
    countryCode: number;
    govCode: number;
    fileSrc?: string | ArrayBuffer;
    fileName?: string
    cityCode: number;
    consultantDateTime?: Date
    hasReport?: string
    consultantName?: string
    doctorFlag?: number
    villageCode: number;
    address: number;
    mobile1: number;
    mobile2: number;
    mobile3: number;
    gender: number;
    birthPlace?: string;
    birthType: number;
    birthDate: Date;
    reportingDate: Date;
    reportingHour: number;
    hospital?: string;
    nameOfReporter?: string;
    kinshipDegree?: string;
    identityNumKid: IIdentity;
    identityNumPapa: IIdentity;
    identityNumMama: IIdentity;
    docName?: string;
    status: number;
    statusNote?: string;
    cancelReason?: string;
    healthStatus?: string;
    uterineAge: number;
    marriageCertificateNumber: number;
    inactive: number;
    year: number;
}
export interface IPatientEmergency extends Patient {
    age: number;
    numberpatient: number;

    serialNumber: number;
    docCode: number;
    dataStatus: number;
    contractId: number;
    startDate: Date;
    endDate: Date;
    triageCode?: number;

}
